<template>
    <v-card v-if="Object.keys(database_modal).length > 0" class="pa-5 modal-info--position" :style="$vuetify.breakpoint.lgAndUp ? 'width:752px' : ''">
        <v-icon class="modal-close" @click.native="closeModal(database_detail_modal)">close</v-icon>
        <v-card-actions>
            <v-layout row justify-space-between align-center>
                <linkRed v-if="database_modal.link_prev && database_modal.link_prev.title!==null" class="mr-4 d-flex align-center link--icon" :class="{'flex xs12': $vuetify.breakpoint.xs}"
                         @click.native="prev_wrap($event)"
                >
                    <svg v-svg v-if="database_modal.link_prev.title"
                         symbol="arrow-left"
                         size="18"
                         class="mr-2"
                         role="presentation"
                    />
                    {{ database_modal.link_prev.title }}
                </linkRed>
                <linkRed v-if="database_modal.link_next && database_modal.link_next.title!==null" class="mr-4 d-flex align-center link--icon"
                         :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="next_wrap($event)"
                >
                    {{ database_modal.link_next.title }}
                    <svg v-svg v-if="database_modal.link_next.title"
                         symbol="arrow-right"
                         size="18"
                         class="ml-2"
                         role="presentation"
                    />
                </linkRed>
            </v-layout>
        </v-card-actions>
        <v-layout class="mt-4">
            <div class="mt-4 mr-3">
                <img v-if="database_modal.image" :src="database_modal.image" alt=""
                     class="modal-image"
                >
            </div>
            <v-flex column style="overflow: hidden">
                <v-card-title class="display-1 my-4">{{ database_modal ? database_modal.title : '' }}</v-card-title>
                <v-layout row wrap align-content-end>
                    <!-- <v-flex xs6 :class="{'sm3': !database_modal.image}">
                        <v-layout column>
                            <v-flex class="grey-text mb-1">{{$t("Дата добавления")}}:</v-flex>
                            <v-flex>{{ get_date(database_modal.add_date) }}</v-flex>
                        </v-layout>
                    </v-flex> -->
                    <v-flex xs6 :class="{'sm3': !database_modal.image}">
                        <v-layout column>
                            <v-flex class="grey-text mb-1">{{ $t("Дата обновления") }}:</v-flex>
                            <v-flex>{{ get_date(database_modal.update_date) }}</v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex v-if="database_modal.links" class="xs12 mt-3">
                        <v-layout>
                            <linkGreen v-for="(link,i) in database_modal.links" :key="i" class="mr-3">{{ link.title }}</linkGreen>
                        </v-layout>
                    </v-flex>
                    <!-- <v-layout align-end :class="{'mt-3': $vuetify.breakpoint.xs, 'flex md3 mt-4': database_modal.image}">
                        <iconLabel icon_name="heart" class="icon-label-red align-content-end" size="23">{{ database_modal.likes || 0 }}</iconLabel>
                    </v-layout> -->
                    <v-layout align-end :class="{'mt-3': $vuetify.breakpoint.xs, 'flex md5 mt-4': database_modal.image}">
                        <iconLabel :icon_name="database_modal.favourite ? 'in-favorites' : 'favorites'" class="icon-label-red align-content-end" size="23"
                                   @click.native="toggle_fav(database_modal)"
                        >{{ $t("В избранное") }}</iconLabel>
                    </v-layout>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout row wrap my-4>
            <component v-for="(block, i) in database_modal.content" :key="i" :content="block.content"
                       :is="block.type"
            />
        </v-layout>
    </v-card>
    <Preloader v-else />
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import linkRed from '@/components/ui/links/styled/link_red';
import linkGreen from '@/components/ui/links/styled/link_green';
import iconLabel from '@/components/ui/icons/icon_with_label';
import documents from '@/components/view_blocks/Database/list_blocks/block_documents.vue';
import slider from '@/components/blocks/content_blocks/block_slider.vue';
import links from '@/components/blocks/content_blocks/block_links.vue';
import crossLinks from '../list_blocks/cross_links.vue';
import htmlText from '@/components/blocks/content_blocks/block_text.vue';
import plainText from '@/components/blocks/content_blocks/block_text.vue';
import list from '@/components/view_blocks/Database/list_blocks/list';
import databaseImproveArticle from './Database_improve_article';
import sliderModal from '@/components/blocks/content_blocks/slider_modal';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
import Preloader from '@/components/blocks/common/preloader.vue';

dayjs.extend(utc);

export default {
  components: {
    Preloader,
    buttonRed,
    buttonBdWhite,
    linkRed,
    linkGreen,
    iconLabel,
    plainText,
    htmlText,
    documents,
    slider,
    links,
    list,
    databaseImproveArticle,
    sliderModal,
    crossLinks,
  },
  data() {
    return {
      crossLinks3: {
        title: 'Продукт',
        type : 'product',
        links: [
          {
            title      : 'API SN',
            database_id: 47,
          },
          {
            title      : 'Porshe A40',
            database_id: 33,
          },
          {
            title      : 'BMW LL-01',
            database_id: 46,
          },
          {
            title      : 'MB-Approval 226.5, 229.5',
            database_id: 130,
          },
        ],
      },
      LINKS: {
        'database_id': '101',
        'image'      : null,
        'title'      : 'SA-SH',
        'add_date'   : 1554200544,
        'update_date': 1554280261,
        'links'      : '',
        'favourite'  : false,
        'likes'      : '',
        'content'    : [
          {
            'type'   : 'plainText',
            'content': {
              'title': 'plainText',
              'text' : '<p>\r\n\t<b>SA-SC</b>\r\n</p>\r\n<p>\r\n\r\n</p>',
            },
          },
          {
            'type'   : 'crossLinks',
            'content': {
              'title': 'Продукты',
              'type' : 'products',
              'links': [
                {
                  'title'      : 'ЛУКОЙЛ SNOW 2T',
                  'database_id': '142',
                },
              ],
            },
          },
        ],
      },
      crossLinks: {
        title: 'Одобрения',
        type : 'oem',
        links: [
          {
            title      : 'API SN',
            database_id: 35,
          },
          {
            title      : 'Porshe A40',
            database_id: 36,
          },
          {
            title      : 'BMW LL-01',
            database_id: 37,
          },
          {
            title      : 'MB-Approval 226.5, 229.5',
            database_id: 38,
          },
        ],
      },
      crossLinks2: {
        title: 'Соответствует требованиям',
        type : 'classification',
        links: [
          {
            title      : 'API SN',
            database_id: 107,
          },
          {
            title      : 'Porshe A40',
            database_id: 108,
          },
          {
            title      : 'BMW LL-01',
            database_id: 109,
          },
          {
            title      : 'MB-Approval 226.5, 229.5',
            database_id: 110,
          },
          {
            title      : 'BMW LL-01',
            database_id: 111,
          },
          {
            title      : 'MB-Approval 226.5, 229.5',
            database_id: 85,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters('common/modals', [
      'slider_modal',
    ]),
    ...mapGetters('database/modal', [
      'database_modal',
      'database_detail_modal',
      'improve_database_article',
      'current_detail',
      'next_title',
      'prev_title',
      'find_ids',
    ]),
    ...mapGetters('database', [
      'current_tab',
    ]),
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  mounted() {
    this.get_detail(this.current_detail.id);
    this.find_prev();
    this.find_next();
  },
  methods: {
    ...mapMutations('contact/requests', [
      'OPEN_CONTACT_MODAL',
    ]),
    ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_PREV_TITLE',
      'SET_NEXT_TITLE',
    ]),
    ...mapActions('database/modal', [
      'get_detail',
      'next_card',
      'prev_card',
    ]),
    ...mapActions('favourites', [
      'toggle_favourites',
    ]),
    async toggle_fav(database_modal) {
      await this.toggle_favourites(database_modal);
      this.get_detail(database_modal.database_id);
    },
    closeModal(name) {
      const url = window.location.href.split('?')[0];
      window.history.pushState({}, 'database', url);

      this.CLOSE_MODAL(name);
    },
    find_next() {
      let idx = this.find_ids.findIndex((item)=>item.database_id==this.current_detail);
      let next = this.find_ids[idx+1] || this.find_ids[0];
      this.SET_NEXT_TITLE(next.title);
    },
    find_prev() {
      let idx = this.find_ids.findIndex((item)=>item.database_id==this.current_detail);
      let prev = this.find_ids[idx-1] || this.find_ids[this.find_ids.length-1];
      this.SET_PREV_TITLE(prev.title);
    },
    get_date(date) {
      return new dayjs(parseInt(date*1000)).utc().format('DD.MM.YYYY');
    },
    get_time(date) {
      return new dayjs(parseInt(date*1000)).utc().format('HH.mm');
    },
    next_wrap(ev) {
      const database_id = this.database_modal.link_prev.database_id;
      const url = window.location.href.split('?')[0] + '?modalId=' + database_id + '&tab=' + this.current_tab;

      ev.target.blur();
      window.history.pushState({}, 'DatabaseModal', url);

      this.next_card(this.database_modal.link_next.database_id);
    },
    prev_wrap(ev) {
      const database_id = this.database_modal.link_prev.database_id;
      const url = window.location.href.split('?')[0] + '?modalId=' + database_id + '&tab=' + this.current_tab;

      ev.target.blur();
      window.history.pushState({}, 'DatabaseModal', url);

      this.prev_card(database_id);
    },
  },

};
</script>
<style lang="less" scoped>
.modal-image {
  width: 220px;
  max-width: none;
}
</style>

